var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  top: -75px;\n  font-size: 24px;\n\n  svg {\n    path {\n      color: ", ";\n      fill: rgba('0,0,0, 1');\n    }\n  }\n"], ["\n  position: absolute;\n  right: 0;\n  top: -75px;\n  font-size: 24px;\n\n  svg {\n    path {\n      color: ", ";\n      fill: rgba('0,0,0, 1');\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (theme.type === 'dark' ? 'rgba(255,255,255, 0.35)' : 'rgba(0, 0, 0, 0.25)');
});
var templateObject_1;
